var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSidebarInactiveSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/setting2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 15.3999C13.2956 15.3999 14.0587 15.0838 14.6213 14.5212C15.1839 13.9586 15.5 13.1956 15.5 12.3999C15.5 11.6043 15.1839 10.8412 14.6213 10.2786C14.0587 9.71597 13.2956 9.3999 12.5 9.3999C11.7044 9.3999 10.9413 9.71597 10.3787 10.2786C9.81607 10.8412 9.5 11.6043 9.5 12.3999C9.5 13.1956 9.81607 13.9586 10.3787 14.5212C10.9413 15.0838 11.7044 15.3999 12.5 15.3999Z",
    stroke: "#515151",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.5 13.2798V11.5198C2.5 10.4798 3.35 9.61984 4.4 9.61984C6.21 9.61984 6.95 8.33984 6.04 6.76984C5.52 5.86984 5.83 4.69984 6.74 4.17984L8.47 3.18984C9.26 2.71984 10.28 2.99984 10.75 3.78984L10.86 3.97984C11.76 5.54984 13.24 5.54984 14.15 3.97984L14.26 3.78984C14.73 2.99984 15.75 2.71984 16.54 3.18984L18.27 4.17984C19.18 4.69984 19.49 5.86984 18.97 6.76984C18.06 8.33984 18.8 9.61984 20.61 9.61984C21.65 9.61984 22.51 10.4698 22.51 11.5198V13.2798C22.51 14.3198 21.66 15.1798 20.61 15.1798C18.8 15.1798 18.06 16.4598 18.97 18.0298C19.49 18.9398 19.18 20.0998 18.27 20.6198L16.54 21.6098C15.75 22.0798 14.73 21.7998 14.26 21.0098L14.15 20.8198C13.25 19.2498 11.77 19.2498 10.86 20.8198L10.75 21.0098C10.28 21.7998 9.26 22.0798 8.47 21.6098L6.74 20.6198C6.3041 20.3689 5.98558 19.9552 5.85435 19.4696C5.72311 18.984 5.78988 18.4662 6.04 18.0298C6.95 16.4598 6.21 15.1798 4.4 15.1798C3.35 15.1798 2.5 14.3198 2.5 13.2798Z",
    stroke: "#515151",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarInactiveSetting);
export default __webpack_public_path__ + "static/media/icon_sidebar_inactive_setting.7d648fe9a3fa9971e9bac8e3bd264cb0.svg";
export { ForwardRef as ReactComponent };